import { NormalizedV2Response } from '@/types/eds/api/responses/NormalizedV2Response';

export const limitDocumentCreatedByAccounts = (documentOrVersion: NormalizedV2Response[]) =>
  documentOrVersion.map((document) => ({
    ...document,
    entities: {
      ...document.entities,
      ...(document.entities.CreatedByPerson
        ? {
            CreatedByPerson: {
              ...document.entities.CreatedByPerson,
              entities: {
                ...(document.entities.CreatedByPerson as NormalizedV2Response).entities,
                Accounts: (
                  (document.entities.CreatedByPerson as NormalizedV2Response)?.entities
                    .Accounts as NormalizedV2Response[]
                )
                  // Take examiner account as priority
                  ?.sort(
                    (acc1, acc2) =>
                      (acc2.fields.portalType?.value === 'Examiner' ? 1 : 0) -
                      (acc1.fields.portalType?.value === 'Examiner' ? 1 : 0),
                  )
                  ?.slice(0, 1),
              },
            },
          }
        : {}),
    },
  }));
